<template>
  <div class="homePage" >
    <header>
      <p v-on:click="backHistory" style="padding-left: 0; " @click=""><img src="@/assets/img/back.png" alt=""></p>
      <!--<p style="padding-right: 2rem;color: #FFFFFF ">保存</p>-->
    </header>
    <div style="padding: 90px 0px">
      <div class="photoDiv" style="" v-for="(index,key) in list">
        <div class="photoTop">
          <div class="photoTopLeft">
            <div class="imgDiv">
              <!--{{index.photo}}-->
              <img v-if="index.photo" class="imgSrc" :src="index.photo" alt="">
              <img v-else="" class="imgSrc" src="@/assets/img/tx.jpg" alt="">
            </div>
            <div class="photoTopRight">
              <span>{{index.name}}</span>
              <span style="font-size: 1px;color:#BEBEBE ">37分钟前在线</span>
            </div>
          </div>
          <div v-if="index.userid!=homeId&&index.isfollow==0" class="clickFollow"  @click="followClick(index,1)" >+关注&nbsp;</div>
          <div v-if="index.userid!=homeId&&index.isfollow==1" class="clickFollow"  @click="followClick(index,2)" >已关注&nbsp;</div>
          <!--<div v-if="index.isfollow==0" class="clickFollow"  @click="followClick(index)" >+关注&nbsp;</div>-->
          <!--<div v-if="index.isfollow==1" class="clickFollow" @click="followClick(index)">已关注&nbsp;</div>-->
          <!--<div v-if="index.isfollow==1" class="clickFollow" @click="colorIconG">已关注&nbsp;</div>-->
          <!--<div v-if="boolG==true" class="clickFollow" @click="colorIconG">已关注&nbsp;</div>-->
        </div>
        <div class="write" style="width: 100%;">
          <div >
            <!--<div v-for="(index,key) in list">-->
            <p class="word">{{index.word}}</p>
            <div class="writeImg"><!--说说-->
              <ul>
                <li v-for="(item, a) in index.img" :key=index >
                  <img :src="item">
                </li>
              </ul>
              <!--<div class="writeImg" v-for="(a,b) in list[key].img">-->
              <!--{{a}}-->
              <!--<img style="width:100px;height: 100px" :src="index.img[key]" alt="" width="">-->
              <!--<img style="width:100px;height: 100px" :src="a" alt="" width="">-->
              <!--</div>-->
            </div>
            <div class="iconDiv"><!--图标-->
              <div>
                <van-icon v-if="index.islike==1" @click="followLiker(index,2)" size="20px" color="red" name="like" />
                <van-icon v-if="index.islike!=1" @click="followLiker(index,1)" size="20px"class="borderColor"  name="like-o" />
                <!--<van-icon v-if="bool==true" @click="colorIcon" size="20px" color="red" name="like" />-->
                <!--<van-icon v-if="bool==false"  size="20px"class="borderColor" @click="colorIcon" name="like-o" />-->
                <!--<van-icon size="20px" class="borderColor" style="margin-left: 10px" name="star-o" />-->
                <!--<van-icon size="20px" class="borderColor" style="margin-left: 10px" name="share-o" />-->
              </div>

              <!--<van-icon size="30px" class="borderColor" name="other-pay" />-->
            </div>
            <div class="comment" ><!--评论-->
              <!--<p>个人简历：看见对方开具收款的JFK收到JFK的数据库</p>-->
              <div>
                <div  style="display: flex">
                  <!--<div style="width: 40px;height: 40px;">-->
                  <!--<img style="width: 100%;height: 100%;border-radius: 100%" src="@/assets/img/tx.jpg" alt="">-->
                  <!--<span>小小</span>-->
                  <!--</div>-->
                  <div style="margin-left:10px;width: 100%  ">
                    <div v-if="index.comment" v-for="(key,number) in index.comment">
                     <p @click="toReply(key)">
                       <span>{{key.name}}:</span>
                       <span style="font-size: 1px;color:#BEBEBE " >{{key.comment}}</span>
                     </p>
                      <p v-for="(a,b) in key.children" @click="toReply(a)">
                        <span>{{a.name}}:回复{{key.name}}</span>
                        <span style="font-size: 1px;color:#BEBEBE " v-if="a.comment">{{a.comment}}</span>
                      </p>
                      <!--<span class="commentZhan"> <van-icon  size="20px"   name="good-job-o" /></span>-->
                    </div>


                    <!--<p style="display: flex;justify-content: space-between">-->
                    <!--<van-icon v-if="boolD==false" size="20px"  @click="colorIconD" name="good-job-o" />-->
                    <!--<van-icon v-else-if="boolD==true" size="20px"  @click="colorIconD" color="#6e9bcf" name="good-job" />-->
                    <!--</p>-->
                  </div>
                </div>
              </div>
              <van-action-sheet v-model="show" title="留下你的评论吧！！">
                <!--<div class="content">内容</div>-->
                <div style="display: flex">
                  <van-field v-model="value"  :placeholder=toReplyName />
                  <div><van-button style="width: 50px" type="primary" size="small" @click="commenter">发送</van-button></div>
                </div>

              </van-action-sheet>
            </div>
            <!--{{index.img[key]}}-->
          </div>
          <!--<img style="width: 100%;height: 100%" src="@/assets/img/aa.jpg" alt="">-->
        </div>


      </div>

    </div>
    <van-tabbar route >
      <van-tabbar-item replace to="/" icon="wap-home-o">
        首页
      </van-tabbar-item>
      <van-tabbar-item replace to="/position" icon="envelop-o">
        职位
      </van-tabbar-item>
      <van-tabbar-item replace @click="href()" icon="fire-o">
        <!--<van-icon name="fire-o" />-->
        社保
      </van-tabbar-item>
      <van-tabbar-item replace to="/firstMessage" icon="desktop-o">
        消息
      </van-tabbar-item>
      <van-tabbar-item replace to="/HelloWorld" icon="contact">
        我的
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
  import  popover  from 'vant';
  const days = ['天', '一', '二', '三', '四', '五', '六']; // 星期数组
  var icnow = new Date();      // 初始化时间
  var interval;
  export default {
    name: 'homePage',
    data () {
      return {
        msg: '',
        name:'',
        show:false,
        showPopover: false,
        toReplyName:'',
        actions: [{ text: '拍摄' }, { text: '相册' }, { text: '写一写' }],
        list:[],
        arr:{},
        bool:false,
        boolD:false,
        boolG:false,
        homeId:localStorage.getItem("userid"),
        year: icnow.getFullYear(),
        month: icnow.getMonth() + 1,
        date: icnow.getDate(),
        day: days[icnow.getDay() - 1],
        time: icnow.toTimeString().substring(0, 8),
        value:'',
        data:[
          {id:1,img:[
            "http://zpapi.yuexinduo.com/upload/img/20201208/78642ac7d4716ac7aec35d5f367af0f3.jpg",

          ]
          },
          {id:1,img:[
            "http://zpapi.yuexinduo.com/upload/img/20201208/78642ac7d4716ac7aec35d5f367af0f3.jpg",
            "http://zpapi.yuexinduo.com/upload/img/20201208/78642ac7d4716ac7aec35d5f367af0f3.jpg",
          ]
          },
          {id:1,img:[
            "http://zpapi.yuexinduo.com/upload/img/20201208/78642ac7d4716ac7aec35d5f367af0f3.jpg",
            "http://zpapi.yuexinduo.com/upload/img/20201208/78642ac7d4716ac7aec35d5f367af0f3.jpg",
            "http://zpapi.yuexinduo.com/upload/img/20201208/78642ac7d4716ac7aec35d5f367af0f3.jpg",
            "http://zpapi.yuexinduo.com/upload/img/20201208/78642ac7d4716ac7aec35d5f367af0f3.jpg",
          ]
          },


        ]
      }
    },
    created () {
      interval = setInterval(() =>{
        let icnow = new Date();
        this.year = icnow.getFullYear();
        this.month = icnow.getMonth() + 1;
        this.date = icnow.getDate();
        this.day = days[icnow.getDay()];
        this.time = icnow.toTimeString().substring(0, 8);
      }, 1000)
    },
    mounted(){
      this.getWrite()
//      this.followClick()
    },
    computed: {
      // 当前时间
      newTime: function () {
//        return this.year + '年' + this.month + '月' + this.date + '日 星期' + this.day + ' ' + this.time;
        return this.month + '月' + this.date + '日' + this.time;
      }
    },
    beforeDestroy () {
      clearInterval(interval);
    },

    methods: {
      onSelect() {
        // 默认情况下点击选项时不会自动收起
        // 可以通过 close-on-click-action 属性开启自动收起
//        this.show = true;
//        Toast(item.name);
      },
      colorIcon(){
        this.bool=!this.bool
      },
      colorIconD(){
        alert(11)
        this.boolD=!this.boolD
        console.log(this.boolD)
      },
      colorIconG(){
        this.boolG=!this.boolG
      },
      href(){
        window.location.href = 'https://m.shangshebao.com';
      },
      backHistory(){
        this.$router.go(-1)
      },
      toReply(index){/*输入评论赋值*/
console.log(index)
//        if(index.name!==this.list[0].name){
          this.show=true,
          this.toReplyName="回复"+index.name+":"
//        }else {
//          this.show=false
//        }
//         console.log()
//        this.list.forEach(function (a,key) {
//          console.log(index)
//          console.log(a)
//          if(a==index){
//
//          }
//        })\
        this.arr=index
      },
      onSelect(action) {
//        Toast(action.text);
        if(action.text=="写一写"){
          this.$router.push("/writer")
        }
        console.log(action.text)
      },
      getWrite(){
        console.log(this.$route.query.id)
        this.$api.getWrite({id:this.$route.query.id})
          .then(res=>{
            this.list=res.data
            console.log(this.list)
          })
      },
      followClick(index,a){
        console.log(index)
        this.$api.follow({
          user_id:localStorage.getItem("userid"),
          follow_user_id:index.userid,
          status:a
        })
          .then(res=>{
            this.getWrite()
//            this.list=res.data
            console.log(this.list)
          })
      },
      followLiker(index,a){
        console.log(index)
        console.log(a)
        this.$api.followLike({
          user_id:localStorage.getItem("userid"),
          news_id:index.id,
          status:a
        })
          .then(res=>{
            this.getWrite()
          })
      },
      commenter(){//评论
        console.log(this.arr)
        this.$api.comment({
          user_id:localStorage.getItem("userid"),
          news_id:this.arr.news_id,
          pid:this.arr.id,
          comment :this.value
        })
          .then(res=>{
            this.show=false
            this.$toast("评论成功")
            this.getWrite()
          })
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
  @import '../assets/css/common.css';
  @import '../assets/css/header.css';
  @import '../assets/css/footer.css';
  .van-search{
    /*margin-top: 3rem;*/
  }
  /**{*/
  /*margin: 0;*/
  /*padding: 0;*/
  /*}*/
  header{
    width: 100%;
    height: 65px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
  }
  header img{
    width: 20px;
    height: 20px;
  }
  .comment{
    width: 80%;
    margin: auto;
    font-size: 13px;
    background: #EEEEEE;
  }
  .commentZhan{
    float: right;
  }
  ul{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  li{
    width: 32%;
    /*height: 100px;*/
    margin-top: 5px;
  }
  .list:not(:nth-child(3n)) {
    margin-right: 2%;
  }
  ul li:nth-last-child(1):first-child{
    width: 200px;
    /*height: 200px;*/
  }
  ul li:nth-last-child(4):first-child ~ li:nth-child(2n){
    margin-right: 32%;
  }
  ul img{
    width: 100%;
  }
  .word{
    width: 80%;
    margin: auto;
  }
  .write{
    /*display: flex;*/
  }
  .writeImg{
    display: flex;
    width: 80%;
    margin: auto;
  }
  .borderColor{
    color: #6e9bcf;
  }
  .searchDiv{
    width: 100%;
    /*display: flex;*/
    background-color: #6e9bcf;
    color: #fff;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .search{
    width: 90%;
  }
  .searchIcon{
    width: 10%;
    display: flex;
    align-items: center;
    background-color: #6e9bcf;
  }
  .follow{
    width: 100%;
    height: 5rem;
    border-bottom: solid 5px #DEDEDE;
    /*background-color: #EEEEEE;*/
    margin-top: 85px;
    display: flex;
  }
  .company{
    /*display: flex;*/
    margin-left: 1.4rem;
  }
  .imgSrc{
    width: 100%;
    border-radius: 100%;
  }
  .imgDiv{
    width: 3.5rem;
    height: 3.5rem;
    background-color: red;
    border-radius: 100%;
  }
  .photoTop{
    display: flex;
    justify-content:space-between;
    align-items:center;/*所有子项沿行内轴中线对齐*/
    padding: 0.8rem 1rem;
    /*margin-top: 6rem;*/
  }
  .photoTopLeft{
    display: flex;
    align-items: center;
  }
  .photoTopRight span{
    display: block;
  }
  .clickFollow{
    background-color: #639DD5;
    color: #FFFFFF;
    border-radius: 3px;
    font-size: 12px;
    padding: 2px;
  }
  .iconDiv{
    display: flex;
    justify-content: space-between;
    width: 80%;
    margin: auto;
    /*margin-top: 1mre;*/
    margin-top: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/homePageDetail.vue